export const countryList: string[] = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Angola',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Benin',
  'Bhutan',
  'Bolivia (Plurinational State of)',
  'Bosnia and Herzegovina',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Caricom',
  'Central African Republic',
  'Chad',
  'Chile',
  'Colombia',
  'Comoros',
  'Congo',
  "Côte d'Ivoire",
  'Cuba',
  "Democratic People's Republic of Korea",
  'Democratic Republic of the Congo',
  'Denmark',
  'Djibouti',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Eritrea',
  'Eswatini',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Haiti',
  'Honduras',
  'Hungary',
  'India',
  'Indonesia',
  'Iran (Islamic Republic of)',
  'Iraq',
  'Ireland',
  'Italy (HQ)',
  'Japan',
  'Jordan',
  'Kenya',
  'Kyrgyz Republic',
  "Lao People's Democratic Republic",
  'Latin America',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Luxembourg',
  'Madagascar',
  'Malawi',
  'Mali',
  'Mauritania',
  'Moldova',
  'Mongolia',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Norway',
  'Pacific (PICT)',
  'Pakistan',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Rebulic of Korea',
  'Republic of Türkiye',
  'Romania',
  'Russia',
  'Russian Federation',
  'Rwanda',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Sierra Leone',
  'Slovakia',
  'Somalia',
  'South Africa',
  'South Sudan',
  'South. Caucasus',
  'Spain',
  'Sri Lanka',
  'State of Palestine',
  'Sudan',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Tajikistan',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tunisia',
  'Uganda',
  'Ukraine',
  'United Arab Emirates (UAE)',
  'United Kingdom (UK)',
  'United Republic of Tanzania',
  'United States (US)',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Yemen',
  'Zambia',
  'Zimbabwe'
]
